export default __webpack_public_path__ + "static/media/148.5ac4ab8c.png";